/**
 * enImport — V55 "Import from your landing page or Instagram" and the
 * per-form "Connect your form" kit. Composed into enIntegrations.
 *
 * Copy rules: every error says what to do next; nothing here claims a
 * feature is live, names an AI client, or quotes a number.
 */
export const enImport = {
  'import.card.title': 'Import from your landing page or Instagram',
  'import.card.body': 'Paste your landing page link (and your Instagram handle if you like). We read the public page and suggest your offers, brand and contact details. Nothing is saved until you choose Apply.',
  'import.card.cta': 'Import my business',
  'import.input.url': 'Landing page link',
  'import.input.urlPlaceholder': 'https://your-site.com',
  'import.input.instagram': 'Instagram handle (optional)',
  'import.input.instagramPlaceholder': '@yourbusiness',
  'import.input.submit': 'Read my page',
  'import.input.reading': 'Reading your page…',
  'import.input.required': 'Paste your landing page link, your Instagram handle, or both.',
  'import.preview.title': 'Here is what we found',
  'import.preview.brand': 'Business',
  'import.preview.contact': 'Contact',
  'import.preview.offers': 'Offers',
  'import.preview.offersHint': 'Untick anything you do not want in your catalog. You can edit names and prices.',
  'import.preview.noOffers': 'No offers were found on this page. You can add them by hand in your catalog after importing.',
  'import.preview.keep': 'Keep',
  'import.preview.name': 'Name',
  'import.preview.type': 'Type',
  'import.preview.price': 'Price',
  'import.preview.priceOnRequest': 'On request',
  'import.preview.type.course': 'Course',
  'import.preview.type.service': 'Service',
  'import.preview.type.product': 'Product',
  'import.preview.forms': 'Forms on this page',
  'import.preview.formFields': '{count} fields',
  'import.preview.booking': 'Booking link',
  'import.preview.seedFlows': 'Add starter automations for my kind of business (saved as drafts; nothing sends until you turn them on)',
  'import.preview.replyTo': 'Use {email} as the Reply-To on my emails',
  'import.preview.replyToHint': 'Replies from your customers go to this address. Leave it unticked if it is not yours.',
  'import.preview.apply': 'Apply',
  'import.preview.applying': 'Saving…',
  'import.preview.back': 'Start over',
  'import.preview.instagram': 'Instagram',
  'import.preview.instagramFrom': 'From Instagram: {name}',
  'import.summary.title': 'Imported',
  'import.summary.catalog': '{created} added, {updated} updated in your catalog',
  'import.summary.planLimit': '{count} not added: your plan’s product limit was reached',
  'import.summary.brand': 'Brand details filled: {fields}',
  'import.summary.field.companyName': 'business name',
  'import.summary.field.logoUrl': 'logo',
  'import.summary.field.primaryColor': 'main colour',
  'import.summary.field.secondaryColor': 'second colour',
  'import.summary.field.websiteUrl': 'website',
  'import.summary.field.replyToEmail': 'reply-to email',
  'import.summary.brandNone': 'Your brand details were already set, so nothing was changed there',
  'import.summary.buzzPageDraft': 'Your BuzzPage was created as a draft with {count} links',
  'import.summary.buzzPageExisting': '{count} links were added to your BuzzPage',
  'import.summary.flows': '{count} starter automations added as drafts',
  'import.summary.openCatalog': 'Open catalog',
  'import.summary.openBuzzPage': 'Open BuzzPage',
  'import.summary.openBrand': 'Open Brand DNA',
  'import.summary.connectForm': 'Connect a form',
  'import.error.generic': 'Something went wrong. Try again in a minute.',
  'import.kit.title': 'Connect your form',
  'import.kit.choose': 'Choose a form',
  'import.kit.build': 'Show the setup',
  'import.kit.mapping': 'Field mapping',
  'import.kit.sentAs': 'sent as {target}',
  'import.kit.notSent': 'not sent',
  'import.kit.copy': 'Copy',
  'import.kit.copied': 'Copied',
  'import.kit.tab.make': 'Make',
  'import.kit.tab.zapier': 'Zapier',
  'import.kit.tab.wordpress': 'WordPress / Elementor',
  'import.kit.tab.wix': 'Wix',
  'import.kit.tab.webflow': 'Webflow',
  'import.kit.tab.script': 'Page script',
  'import.kit.tab.curl': 'Command line',
  'import.kit.testTitle': 'Send a test lead',
  'import.kit.testEmail': 'Test email address',
  'import.kit.testSend': 'Send a test lead',
  'import.kit.testSending': 'Sending…',
  'import.kit.testAccepted': 'Received. The test contact was created.',
  'import.kit.testRuns': 'Automation started: {name} (run {id})',
  'import.kit.testNoRun': 'Received, but no automation started. Turn on an automation that starts when a new lead arrives, then send another test.',
  'import.kit.testNoConsent': 'Email skipped: no consent. This address has not opted in to marketing email, so the automation will not email it. To receive the test email, send the test to your own account address (or a +label version of it).',
  'import.kit.testPending': 'Received. It is still being processed; check your contacts in a minute.',
  'import.kit.testRejected': 'The test was refused ({reason}). Click "Show / rotate signing secret", update your form tool with the new secret, then try again.',
  'import.integrations.importCta': 'Import from my page',
  'import.onboarding.title': 'Connect your landing page',
};
